<template>
  <div class="Chart">
    <canvas :id="'chartjsdiv_'+ data.id"></canvas>
  </div>
</template>

<script>

import Chart from 'chart.js';


export default {
  name: 'Chartjs',
  
  props: {
    data: Object,
    
  },
  data() {
    return {
      

    }
  },
  mounted () {
    
    
    var objData = {
       id: this.data.id,
    
    }
   
    this.$store.dispatch('getLast', objData)
    .then(response => {
      //console.log("getLast")
      //console.log(response.data[0])
      this.buildChart(response.data[0])
    })
    .catch(error => {
        console.log(error)
        return error
    });
  },
  
  methods: {
      buildChart(_data){

        

        var data = {
                labels: ['1.CWU', '2.CWU-cyrkulacja', '3.CO-zasilanie', '4.CO-cyrkulacja', '5.Kotły'],
                datasets: [{
                    label: _data.date,
                    backgroundColor: [
                      'rgba(0,153,255,.7)', 
                      'rgba(0,204,0,.7)',
                      'rgba(255,0,0,.7)',
                      'rgba(255,204,0,.7)',
                      'rgba(204,102,255,.7)',
                      
                    ],
                    borderColor: [
                      '#0099FF',
                      '#00CC00',
                      '#FF0000',
                      '#FFCC00',
                      '#CC66FF'
                      
                    ],
                    data: [_data.t1, _data.t2, _data.t3, _data.t4, _data.t5]
                  }
                ]
            }

          var ctx = document.getElementById('chartjsdiv_'+ this.data.id).getContext('2d');
          //console.log(data)
            var chart = new Chart(ctx, {
                type: 'bar',
                data: data,
                options: {
                  responsive: true,
                  
                  legend: {
                    position: 'top',
                    display: false
                  },
                  title: {
                    display: true,
                    text: _data.date
                  },
                  scales: {
                        yAxes: [{
                            ticks: {
                                suggestedMin: 0,
                                suggestedMax: 70
                            }
                        }]
                    }
                }
            });

            
      }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .card{
    margin: 10px;
  }
  .graphdiv{
    width: auto;
    height: 200px;
  }
  .dygraph-legend{
    float: right;
  }

</style>
